import * as React from "react";
import * as styles from "./styles.scss";
import cx from "classnames";
import { MobXProviderContext, observer } from "mobx-react";

import { Box, Hidden, Tab, Tabs } from "@material-ui/core";

export const TabsList = observer(() => {
  const { fsStore, fsCourseStore, fsTabsStore } = React.useContext(
    MobXProviderContext
  );

  return fsCourseStore.isTabsVisible ? (
    <Box px={2} className={styles.tabs}>
      <Tabs
        value={fsCourseStore.filesSection + "-" + fsCourseStore.filesSectionTab}
        onChange={(event: React.ChangeEvent<{}>, newTab: any) => {
          fsCourseStore.setFilesSectionAndTab(
            newTab.split("-")[0],
            newTab.split("-")[1]
          );
        }}
        indicatorColor="primary"
        textColor="primary"
      >
        {fsTabsStore.getFSTabs.map((tab: any, i: number) => (
          <Tab
            key={`fs_tab-${i}`}
            value={tab.section + "-" + tab.tab}
            label={
              tab.labelMobile ? (
                <Box component="span">
                  <Hidden only="xs">
                    {tab.labelOfType &&
                    tab.labelOfType[fsCourseStore.filterFilesType]
                      ? tab.labelOfType[fsCourseStore.filterFilesType]
                      : tab.label}
                  </Hidden>
                  <Hidden smUp>
                    {tab.labelOfTypeMobile &&
                    tab.labelOfTypeMobile[fsCourseStore.filterFilesType]
                      ? tab.labelOfTypeMobile[fsCourseStore.filterFilesType]
                      : tab.labelMobile}
                  </Hidden>
                </Box>
              ) : (
                <Box component="span">
                  {tab.labelOfType &&
                  tab.labelOfType[fsCourseStore.filterFilesType]
                    ? tab.labelOfType[fsCourseStore.filterFilesType]
                    : tab.label}
                </Box>
              )
            }
          />
        ))}
      </Tabs>
    </Box>
  ) : null;
});
